import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getNombreFromToken } from '../../services/auth';
import '../../styles/admin/AdminLayout.css';

// Importar ventanas administrativas
import AdminDashboard from './AdminDashboard';
import AdminUsuarios from './AdminUsuarios';
import AdminCampanias from './AdminCampanias';
import AdminContenido from './AdminContenido';
import AdminPagos from './AdminPagos';
import AdminConsumo from './AdminConsumo';

function AdminLayout() {
  const [seccionActual, setSeccionActual] = useState('dashboard');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const nombre = getNombreFromToken();
    setNombreUsuario(nombre || 'Usuario');
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const renderSeccion = () => {
    switch (seccionActual) {
      case 'dashboard': return <AdminDashboard />;
      case 'usuarios': return <AdminUsuarios />;
      case 'campanias': return <AdminCampanias />;
      case 'contenido': return <AdminContenido />;
      case 'pagos': return <AdminPagos />;
      case 'consumo': return <AdminConsumo />;
      default: return <AdminDashboard />;
    }
  };

  const menuItems = [
    { id: 'dashboard', icon: '📊', label: 'Dashboard' },
    { id: 'usuarios', icon: '👥', label: 'Usuarios' },
    { id: 'campanias', icon: '🚀', label: 'Campañas' },
    { id: 'contenido', icon: '📝', label: 'Contenido' },
    { id: 'pagos', icon: '💰', label: 'Pagos' },
    { id: 'consumo', icon: '📈', label: 'Consumo' },
  ];

  return (
    <div className="admin-layout">
      {/* BARRA LATERAL */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <img 
            src="/logo2.png" 
            alt="Sinteligen" 
            className="admin-logo-img"
          />
        </div>

        <nav className="admin-sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setSeccionActual(item.id)}
              className={`admin-sidebar-btn ${seccionActual === item.id ? 'active' : ''}`}
              title={item.label}
            >
              <span className="admin-sidebar-icon">{item.icon}</span>
            </button>
          ))}
        </nav>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <main className="admin-main">
        <header className="admin-header">
          <div className="admin-header-left">
            <img 
              src="/sinteligen4.png" 
              alt="Sinteligen" 
              className="admin-header-logo"
            />
          </div>

          <div className="admin-header-right">
            <span className="admin-user-name">👤 {nombreUsuario}</span>
            <button className="admin-logout-btn" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </header>

        <div className="admin-content">
          {renderSeccion()}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;